import type { CSSObject } from "@mui/material/styles";

export const MELA_DIALOG_RESERVED_RAIL_WIDTH_VAR =
  "--mela-dialog-reserved-rail-width";

/** Height the compact chat launcher covers; set on <html> only while it is shown. */
export const MELA_CHAT_LAUNCHER_CLEARANCE_VAR =
  "--mela-chat-launcher-clearance";

export const MELA_POPUP_ABOVE_CHAT_RAIL_Z_INDEX = 30050;

const DIALOG_CONTAINER_TRANSITION = "padding-right 200ms ease";

export const MELA_DIALOG_VIEWPORT_MARGIN = 64;
export const MELA_DIALOG_WORKSPACE_GUTTER = 16;

export const MELA_DIALOG_AVAILABLE_WIDTH = `calc(100vw - var(${MELA_DIALOG_RESERVED_RAIL_WIDTH_VAR}, 0px) - ${MELA_DIALOG_VIEWPORT_MARGIN + MELA_DIALOG_WORKSPACE_GUTTER * 2}px)`;

export const melaRailAwareDialogContainerSx: CSSObject = {
  boxSizing: "border-box",
  paddingRight: `var(${MELA_DIALOG_RESERVED_RAIL_WIDTH_VAR}, 0px)`,
  transition: DIALOG_CONTAINER_TRANSITION,
};
